/**
 * Applies the stored language. Imported first in main.tsx so it runs before the store and
 * initial design (whose default names are translated) are created.
 */
import { loadStoredLang, setLang } from './i18n';

const lang = loadStoredLang();
setLang(lang);
if (typeof document !== 'undefined') document.documentElement.lang = lang;
